import { render } from "./SomethingWrongModal.vue?vue&type=template&id=dc37a564"
import script from "./SomethingWrongModal.vue?vue&type=script&lang=js"
export * from "./SomethingWrongModal.vue?vue&type=script&lang=js"

import "./SomethingWrongModal.vue?vue&type=style&index=0&id=dc37a564&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__